import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";

class PeopleDataProvider extends BaseDataProvider {
  async getOne(resource, params) {
    console.log(
      "PeopleDataProvider.getOne(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const GET = gql`
          query {
            PersonByID(id:"${params.id}") {
              id
              stableId
              firstName
              lastName
              middleInitial
              name
              isStub
              seasonTeamPlayers {
                id
                team {
                  seasonCode
                  sportCode
                  team {
                    name
                  }
                }
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.PersonByID };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async delete(resource, params) {
    console.log(
      "PersonDataProvider.delete(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    let infoString = JSON.stringify({ id: params.id }).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    infoString = infoString.substring(1, infoString.length - 1).trim();
    const DESTROY_OBJECT = gql`
            mutation {
              DeletePersonByID(${infoString})
            }`;
    const response = await this.client.mutate({ mutation: DESTROY_OBJECT });
    if (!response) throw new Error("BAD:", JSON.stringify(response));
    return { data: params.previousData };
  }

  async update(resource, params) {
    console.log(
      "PeopleDataProvider.update(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    delete objectInfo.__typename;
    delete objectInfo.seasonTeamPlayers;
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const MUTATION = gql`
          mutation {
            UpdatePerson(${objectString}) {
              id
              stableId
              firstName
              lastName
              middleInitial
              name
              isStub
            }
          }`;
    try {
      const response = await this.client.mutate({ mutation: MUTATION });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.UpdatePerson };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async create(resource, params) {
    console.log(
      "PeopleDataProvider.create(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const CREATE_OBJECT = gql`
          mutation {
            CreatePerson(${objectString}) {
              id
              stableId
              firstName
              lastName
              middleInitial
              name
              isStub
            }
          }`;
    const response = await this.client.mutate({ mutation: CREATE_OBJECT });
    return { data: response.data.CreatePerson };
  }

  async getList(resource, params) {
    console.log(
      "PeopleDataProvider.getList(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const name = params.filter.name ? params.filter.name : "";
    const offset = params.pagination.page
      ? (params.pagination.page - 1) * params.pagination.perPage
      : 0;
    const limit = params.pagination.perPage ? params.pagination.perPage : 10;
    const GET = gql`
          query {
            PeopleSearch(name:"${name}" offset:${offset} limit:${limit}) {
              offset
              limit
              total
              data {
                id
                stableId
                firstName
                lastName
                middleInitial
                name
                isStub
                seasonTeamPlayers {
                  id
                  team {
                    seasonCode
                    sportCode
                    team {
                      name
                    }
                  }
                }
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(JSON.stringify(response, null, 2));
      return response.data.PeopleSearch;
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }
}

export default PeopleDataProvider;
